import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { navigationLinks } from '../../../config/navigation';
import { isAdmin } from '../../../lib/ruoli';

/**
 * Barra di navigazione flottante (pill) ancorata in basso.
 * Le voci riservate all'admin compaiono solo per gli amministratori
 * (livello 0 globale e livello 1 di condominio).
 */
export default function BottomNav({ isLogged, userInfo }) {
    const location = useLocation();
    const amministratore = isAdmin(userInfo);
    const visible = Boolean(isLogged && userInfo);

    const links = navigationLinks.filter(link => !link.adminOnly || amministratore);

    useEffect(() => {
        document.body.classList.toggle('lv-has-bottomnav', visible);
        return () => document.body.classList.remove('lv-has-bottomnav');
    }, [visible]);

    if (!visible) return null;

    return (
        <nav id="lv-bottomnav" aria-label="Navigazione principale">
            {links.map(link => {
                const active = location.pathname === link.path
                    || location.pathname.startsWith(`${link.path}/`);
                return (
                    <Link
                        key={link.path}
                        to={link.path}
                        className={`lv-navitem${active ? ' active' : ''}`}
                        aria-current={active ? 'page' : undefined}
                    >
                        <FontAwesomeIcon icon={['fas', link.icon]} />
                        <span className="lv-navitem-label">{link.label}</span>
                    </Link>
                );
            })}
        </nav>
    );
}
